import React from "react";
import {message, Modal, Icon} from "antd/lib/index";
import {getBaseUrl} from "./config";
import {getCookie} from "./cookie";
import { Statistic } from 'antd';
import { addExportRequest } from "../api/basicApi";
import { CRM_SCHOOL_TYPE } from "./keys";
const { confirm } = Modal;
const { Countdown } = Statistic;



/**
 * 2019-05-14
 * Created by Jeremy.caoyu
 * CRM基础验证函数
 *
 */


export const isIP = (ip) => {
    let reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
    if (reg.test(ip) && (RegExp.$1<256 && RegExp.$2<256 && RegExp.$3<256 && RegExp.$4<256)) {
        return true;
    } else {
        return false;
    }
}

export function padding(v) {
    let value = v + '';
    if (value.length < 2) {
        value = '0' + value;
    }
    return value;
}
//时间转换 => YYYY-MM-dd
export function format(d) {
    return !!d && typeof d !== 'string' ? (d.getFullYear() + '-' + padding(d.getMonth() + 1) + '-' + padding(d.getDate())) : d;
}

export function number2DateTime(value, fmt = 'yyyy-MM-dd HH:mm:ss') { // yyyy-MM-dd HH:mm:ss
    if (isNaN(value)) return '';
    const date = new Date(Number(value));
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    return fmt.replace('yyyy', year.toString())
        .replace('yy', (year % 100).toString())
        .replace('MM', month > 9 ? month.toString() : ("0" + month))
        .replace('dd', day > 9 ? day.toString() : ("0" + day))
        .replace('HH', hour > 9 ? (hour).toString() : ("0" + hour))
        .replace('mm', minute > 9 ? (minute).toString() : ("0" + minute))
        .replace('ss', second > 9 ? (second).toString() : ("0" + second));
}
export function isPhone(str) { // 手机号验证
                               // let reg = /^(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8}$/;
    let reg = /^1[3-9][0-9]{9}$/;
    if (reg.test(str)) {
        return true;
    } else {
        return false;
    }
}
export function isTel(str) { // 座机验证
                             // let reg = /([0-9]{3,4}-)?[0-9]{7,8}/;
    let reg = /0\d{2}-\d{7,8}/;
    if (reg.test(str)) {
        return true;
    } else {
        return false;
    }
}
export function isNumber(value) {
    let patrn = /^[0-9]*$/;
    if (patrn.exec(value) === null || value === "") {
        return false
    } else {
        return true
    }

}
export function isQQ(str) { // QQ号验证
    let reg = /^[1-9][0-9]{4,15}$/
    if (reg.test(str)) {
        return true;
    } else {
        return false;
    }
}
export function isEmail(str) { // 邮箱验证
    let reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
    // let reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    if (reg.test(str)) {
        return true;
    } else {
        return false;
    }
}
export function checkIDCard(str) { // 身份证验证
    const patternMainLand = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/,//大陆
        patternHongkong = /([A-Za-z](\d{6})\d)|(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)/, //香港、大陆
        patternTaiwan = /^[a-zA-Z][0-9]{9}$/,//台湾
        patternMacao = /^[1|5|7][0-9]{6}[0−9Aa]/;//澳门
    if (
        patternMainLand.test(str) ||
        patternHongkong.test(str) ||
        patternTaiwan.test(str) ||
        patternMacao.test(str)
    ) {
        return true;
    } else {
        return false;
    }
}



/**
 * 获取本周、本季度、本月、上月的开端日期、停止日期
 */
let now = new Date(); //当前日期
let nowDayOfWeek = now.getDay() || 7; //今天本周的第几天
let nowDay = now.getDate(); //当前日
let nowMonth = now.getMonth(); //当前月
let nowYear = now.getFullYear(); //当前年
nowYear += (nowYear < 2000) ? 1900 : 0;

//获得某月的天数
export function getMonthDays(myMonth) {
    let monthStartDate = new Date(nowYear, myMonth, 1);
    let monthEndDate = new Date(nowYear, myMonth + 1, 1);
    let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
    return days;
}

//获得本周的开端日期
export function getWeekStartDate() {
    let weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
    return format(weekStartDate);
}
//获得本周的停止日期
export function getWeekEndDate() {
    let weekEndDate = new Date(nowYear, nowMonth, nowDay + (7 - nowDayOfWeek));
    return format(weekEndDate);
}

// 获取指定日期所在周的开端日期
export function  getAssignWeekStartDate(date) {
    const nowDate = new Date(date),
        nowYear = nowDate.getFullYear(), //当前年
        nowMonth = nowDate.getMonth(), //当前月
        nowDay = nowDate.getDate(), //当前日
        nowDayOfWeek = nowDate.getDay() || 7
    let weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
    return format(weekStartDate);
}

// 获取指定日期所在周的停止日期
export function  getAssignWeekEndDate(date) {
    const nowDate = new Date(date),
        nowYear = nowDate.getFullYear(), //当前年
        nowMonth = nowDate.getMonth(), //当前月
        nowDay = nowDate.getDate(), //当前日
        nowDayOfWeek = nowDate.getDay() || 7
    let weekEndDate = new Date(nowYear, nowMonth, nowDay + (7 - nowDayOfWeek));
    return format(weekEndDate);
}

//获得本月的开端日期
export function getMonthStartDate() {
    let monthStartDate = new Date(nowYear, nowMonth, 1);
    return format(monthStartDate);
}

//获得本月的停止日期
export function getMonthEndDate() {
    let monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth));
    return format(monthEndDate);
}

//将"2018-05-19T08:04:52.000+0000"这种格式的时间转化为正常格式
export function timeFormat(time) {
    let d = new Date(time);

    let year = d.getFullYear();       //年
    let month = d.getMonth() + 1;     //月
    let day = d.getDate();            //日

    let hh = d.getHours();            //时
    let mm = d.getMinutes();          //分
    let ss = d.getSeconds();           //秒

    let clock = year + "-";

    if (month < 10)
        clock += "0";

    clock += month + "-";

    if (day < 10)
        clock += "0";

    clock += day + " ";

    if (hh < 10)
        clock += "0";

    clock += hh + ":";
    if (mm < 10) clock += '0';
    clock += mm + ":";

    if (ss < 10) clock += '0';
    clock += ss;
    return (clock);
}



export function GetQueryString (searchUrl=window.location.search || (window.location.hash.split('?')[1]), name) {
    let search = searchUrl && searchUrl.replace(/\?/, '').split('&')
    let data = {}
    search && search.forEach((item, index) => {
        let items = item.split('='),
            key = items[0],
            val = items[1]
        data[key] = decodeURI(val)
    })
    return name ? data[name] : data
}

// 生日 计算年龄
export function jsGetAge (strBirthday){
    let returnAge;
    let strBirthdayArr=strBirthday.split("-");
    let birthYear = strBirthdayArr[0];
    let birthMonth = strBirthdayArr[1];
    let birthDay = strBirthdayArr[2];

    let d = new Date();
    let nowYear = d.getFullYear();
    let nowMonth = d.getMonth() + 1;
    let nowDay = d.getDate();

    if(nowYear === birthYear){
        returnAge = 0;//同年 则为0岁
    } else {
        let ageDiff = nowYear - birthYear ; //年之差
        if(ageDiff > 0){
            if(nowMonth === birthMonth) {
                let dayDiff = nowDay - birthDay;//日之差
                if(dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff ;
                }
            } else {
                let monthDiff = nowMonth - birthMonth;//月之差
                if(monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff ;
                }
            }
        } else  {
            returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return returnAge < 0 ? 0 : returnAge ;//返回周岁年龄
}

export const CallActionList = {
    signIn: '签入',
    signOut: '签出',
    setIdle: '置闲',
    setBusy: '置忙',
    setMonitor: '监控',
    setHangup: '挂断',
}
export const CallStatusList = [{
    name: '未签入',
    canAction: [{key: 'signIn', name: '签入'}],
}, {
    name: '空闲中',
    canAction: [{key: '签出', name: 'signOut'}, { key: 'setBusy', name: '置忙' }, { key: 'setMonitor', name: '监控' }],
}, {
    name: '忙碌中',
    canAction: [{key: '签出', name: 'signOut'}, { key: 'setIdle', name: '置闲' }, { key: 'setMonitor', name: '监控' }],
}, {
    name: '通话中',
    canAction: [{key: '签出', name: 'signOut'}, { key: 'setIdle', name: '置闲' }, { key: 'setMonitor', name: '监控' }],
}]


export const checkCallStatus = (CallCenterStatus) => {
    return new Promise(resolve => {
        switch (CallCenterStatus) {
            case 1:
                message.warning('请先签入,再拨打电话')
                resolve(false)
                break;
            case 2:
                resolve(true)
                break;
            case 3:
                message.warning('请先置闲,再拨打电话')
                resolve(false)
                break;
            case 4:
                message.warning('座席忙，请结束当前通话后再拨')
                resolve(false)
                break;
            default:
                message.warning('请先签入,再拨打电话')
                resolve(false)
                break;
        }
    })
}

export const exportExl = (url,data={},fileName='', methods='post', type=1) => {
    let xhr = new XMLHttpRequest()
    xhr.open(methods, getBaseUrl() + url, true)
    xhr.responseType = 'blob'
    xhr.setRequestHeader("Authorization", getCookie('CRM_TOKEN')) // 请求头中的验证信息等（如果有）
    xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8")
    xhr.onload = function() {
        if (this.status === 200) {
            let type = xhr.getResponseHeader('Content-Type')
            let blob = new Blob([this.response], {type: type})
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                window.navigator.msSaveBlob(blob, fileName)
            } else {
                let URL = window.URL || window.webkitURL
                let objectUrl = URL.createObjectURL(blob)
                if (fileName) {
                    let a = document.createElement('a')
                    if (typeof a.download === 'undefined') {
                        window.location = objectUrl
                    } else {
                        a.href = objectUrl
                        a.download = fileName
                        document.body.appendChild(a)
                        a.click()
                        a.remove()
                    }
                } else {
                    window.location = objectUrl
                }
            }
        }
    }
    xhr.send(JSON.stringify(data))
}



// 导出页面
export const ExportPageNo = () => {
    return {
        p001: '销售中心-学员档案-潜在学员',
        p003: '销售中心-学员档案-在读学员',
        p004: '销售中心-学员档案-历史学员',
        p005: '销售中心-邀约管理-试听课',
        p006: '销售中心-邀约管理-邀约到店',
        p007: '销售中心-邀约管理-预约试听',
        p008: '销售中心-知识漏洞体检-体检报告',
        p009: '销售中心-知识漏洞体检-体检测评组',
        p011: '销售中心-知识漏洞体检-邀约只是漏洞大体检',
        p012: '销售中心-公海池',
        p013: '财务中心-订单管理',
        p014: '财务中心-电子账户-消费记录',
        p015: '财务中心-电子账户-充值记录',
        p016: '财务中心-电子账户-退转记录',
        p017: '财务中心-电子账户-开票记录',
        p018: '财务中心-学员退费-退款列表',
        p019: '教务中心-学员管理-在读学员',
        p020: '教务中心-学员管理-历史学员',
        p021: '教务中心-学员管理-活动学员',
        p022: '教务中心-班级管理-班课',
        p023: '教务中心-校区课表-分析员课表',
        p024: '教务中心-校区课表-学员课表',
        p025: '教务中心-学员智适应记录-课程上课记录',
        p026: '教务中心-学员智适应记录-课时课消对账单',
        p027: '教务中心-学员智适应记录-学员学情',
        p028: '教务中心-学员智适应记录-知识点明细',
        p029: '教务中心-智适应课时预警',
        p030: '教学中心-分析员管理',
        p031: '教学中心-教学质检-分析员授课列表',
        p032: '教学中心-超级监课',
        p033: '教学中心-备课磨课',
        p042: '校区课表-综合课表',
        p048: '活动报表-热力赛S3中奖名单'
    }
}
//  导出列表Excel
export const ExportRequest = (data, pageNo, history) => {
    const deadline = Date.now() + 10 * 60 * 9  ; //
    let canClick = false
    addExportRequest({
        ...data,
    }, pageNo).then(ret => {
        if (ret.code === 0) {
            const onFinish = () => {
                canClick = true
                nowConfirm.update({
                    okButtonProps:{
                        disabled: false
                    },
                    okText: (
                        <div style={{display:'inline-flex'}} >
                            去查看
                        </div>
                    )
                })
            }

            var nowConfirm = confirm({
                icon: <Icon type="check-circle" theme="filled" style={{color: "#52c41a"}}/>,
                content:
                    <div>
                        {
                            ret.code === 0 ?
                                <div>
                                    <h3>导出任务提交成功</h3>
                                    <p>请前往「导出导入」进行下载</p>
                                </div>
                                :
                                <div>
                                    <h3>文件已导出，请到导出列表进行下载</h3>
                                </div>
                        }
                    </div>
                ,
                confirmLoading: false,
                cancelText: "我知道了",
                okButtonProps:{
                    disabled: true
                },
                okText: (
                    <div className="flex_center">
                        去查看
                        (<Countdown className="ReportCount"   value={deadline || ''} format="s" style={{display:'block',color:'white',fontSize:'20px'}} onFinish={onFinish}   /><span >s</span>)
                    </div>
                ),
                onOk() {
                    return new Promise((resolve, reject) => {
                        if (!canClick) {
                            reject()
                            return false
                        } else {
                            history.push(`/main/ExportImportQuery/ExportQuery`)
                            resolve()
                        }
                    })
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        }
        else if(ret.code === 1){
            // const onFinish = () => {
            //     canClick = true
            //     nowConfirm1.update({
            //         okText: (
            //             <div style={{display:'inline-flex'}} >
            //                 去查看
            //             </div>
            //         )
            //     })
            // }
            confirm({
                icon: <Icon type="exclamation-circle" theme="filled" style={{color: "#faad14"}}/>,
                content:
                    <div>
                        <div>
                            <h3>文件已导出，请到导出列表进行下载</h3>
                        </div>
                    </div>
                ,
                confirmLoading: false,
                cancelText: "我知道了",
                okText: "去查看" ,
                onOk() {
                    history.push(`/main/ExportImportQuery/ExportQuery`)
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        }
    })


}

//  导出列表Excel
export const ExportRequest1 = (data, pageNo, history) => {
    const deadline = Date.now() + 10 * 60 * 9  ; //
    let canClick = false
    addExportRequest({
        ...data,
    }, pageNo).then(ret => {
        if (ret.code === 0) {
            const onFinish = () => {
                canClick = true
                nowConfirm.update({
                    okButtonProps:{
                        disabled: false
                    },
                    okText: (
                        <div style={{display:'inline-flex'}} >
                            去查看
                        </div>
                    )
                })
            }

            var nowConfirm = confirm({
                icon: <Icon type="check-circle" theme="filled" style={{color: "#52c41a"}}/>,
                content:
                    <div>
                        {
                            ret.code === 0 ?
                                <div>
                                    <h3>导出任务提交成功</h3>
                                    <p>请前往「导出导入」进行下载</p>
                                </div>
                                :
                                <div>
                                    <h3>文件已导出，请到导出列表进行下载</h3>
                                </div>
                        }
                    </div>
                ,
                confirmLoading: false,
                cancelText: "我知道了",
                okButtonProps:{
                    disabled: true
                },
                okText: (
                    <div className="flex_center">
                        去查看
                        (<Countdown className="ReportCount"   value={deadline || ''} format="s" style={{display:'block',color:'white',fontSize:'20px'}} onFinish={onFinish}   /><span >s</span>)
                    </div>
                ),
                onOk() {
                    return new Promise((resolve, reject) => {
                        if (!canClick) {
                            reject()
                            return false
                        } else {
                            history.push(`/main/ExportImportQuery/AgentExportQuery`)
                            resolve()
                        }
                    })
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        }
        else if(ret.code === 1){
            // const onFinish = () => {
            //     canClick = true
            //     nowConfirm1.update({
            //         okText: (
            //             <div style={{display:'inline-flex'}} >
            //                 去查看
            //             </div>
            //         )
            //     })
            // }
            confirm({
                icon: <Icon type="exclamation-circle" theme="filled" style={{color: "#faad14"}}/>,
                content:
                    <div>
                        <div>
                            <h3>文件已导出，请到导出列表进行下载</h3>
                        </div>
                    </div>
                ,
                confirmLoading: false,
                cancelText: "我知道了",
                okText: "去查看" ,
                onOk() {
                    history.push(`/main/ExportImportQuery/ExportQuery`)
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        }
    })


}

//节流
export const throttle=(fn,interval=3000)=>{
    let enterTime=0;
    let gapTime=interval||1000;
    return function(e){
        let backTime=new Date();
        if(backTime-enterTime>gapTime){
            fn(this, e);
            enterTime=backTime;
        }
    }
}
export function trim(str) { // 去空格
    return str.replace(/\s/g, '');
}
//是否为数组
export function isArray(arr){
    return Object.prototype.toString.call(arr)==='[object Array]';
}

export function getSelectVal (node) {
    return new Promise(resolve => {
        let selectArr = []
        function parseNode (nodeList) {
            nodeList.forEach(item => {
                if (
                    item.node && item.node.props && item.node.props.value && (item.node.props.value.split('_')[1]-0 > 0)
                ) {
                    selectArr.push(item.node.props.value.split('_')[1]-0)
                } else if (item.props && item.props.value && (item.props.value.split('_')[1]-0 > 0)) {
                    selectArr.push(item.props.value.split('_')[1]-0)
                }
                if (item.children && (item.children.length > 0)) {
                    parseNode(item.children)
                }
            })
        }
        parseNode(node);
        selectArr = [...new Set(selectArr)];
        resolve(selectArr)
    })
};
//秒转时分
export function formatSeconds(value) {
    let result = parseInt(value)
    let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)||'0';
    let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))||'0';
    // let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

    let res = '';
    if (h !== '00') res += `${h}小时`;
    if (m !== '00') res += `${m}分`;
    //res += `${s}s`;
    return res;
}

// 文字水印

export function addWaterMarker(settings) {
    //默认设置
    var defaultSettings={
        watermark_txt:"text",
        watermark_x:20,//水印起始位置x轴坐标
        watermark_y:20,//水印起始位置Y轴坐标
        watermark_rows:20,//水印行数
        watermark_cols:20,//水印列数
        watermark_x_space:100,//水印x轴间隔
        watermark_y_space:50,//水印y轴间隔
        watermark_color:'#aaa',//水印字体颜色
        watermark_alpha:0.4,//水印透明度
        watermark_fontsize:'15px',//水印字体大小
        watermark_font:'微软雅黑',//水印字体
        watermark_width:100,//水印宽度
        watermark_height:40,//水印长度
        watermark_angle:15,//水印倾斜度数
    };
    //采用配置项替换默认值，作用类似jquery.extend
    if(arguments.length===1&&typeof arguments[0] ==="object" )
    {
        var src=arguments[0]||{}, key;
        for(key in src)
        {
            if(src[key]&&defaultSettings[key]&&src[key]===defaultSettings[key])
                continue;
            else if(src[key])
                defaultSettings[key]=src[key];
        }
    }
    var oTemp = document.createDocumentFragment();

    //获取页面最大宽度
    let page_width = Math.max(document.body.scrollWidth,document.body.clientWidth);
    var cutWidth = page_width*0.0150;
    page_width=page_width-cutWidth;
    //获取页面最大高度
    var page_height = Math.max(document.body.scrollHeight,document.body.clientHeight)+450;
    // var page_height = document.body.scrollHeight+document.body.scrollTop;
    //如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
    if (defaultSettings.watermark_cols === 0 || (parseInt(defaultSettings.watermark_x + defaultSettings.watermark_width *defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)) > page_width)) {
        defaultSettings.watermark_cols = parseInt((page_width-defaultSettings.watermark_x+defaultSettings.watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space));
        defaultSettings.watermark_x_space = parseInt((page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1));
    }
    //如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
    if (defaultSettings.watermark_rows === 0 || (parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height)) {
        defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space));
        defaultSettings.watermark_y_space = parseInt(((page_height - defaultSettings.watermark_y) - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1));
    }
    var x;
    var y;
    for (var i = 0; i < defaultSettings.watermark_rows; i++) {
        y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
        for (var j = 0; j < defaultSettings.watermark_cols; j++) {
            x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;

            var mask_div = document.createElement('div');
            mask_div.id = 'mask_div' + i + j;
            mask_div.className = 'mask_div';
            mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));
            //设置水印div倾斜显示
            mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            mask_div.style.visibility = "";
            mask_div.style.position = "absolute";
            mask_div.style.left = x + 'px';
            mask_div.style.top = y + 'px';
            mask_div.style.overflow = "hidden";
            mask_div.style.zIndex = "9999";
            mask_div.style.pointerEvents='none';//pointer-events:none  让水印不遮挡页面的点击事件
            //mask_div.style.border="solid #eee 1px";
            mask_div.style.opacity = defaultSettings.watermark_alpha;
            mask_div.style.fontSize = defaultSettings.watermark_fontsize;
            mask_div.style.fontFamily = defaultSettings.watermark_font;
            mask_div.style.color = defaultSettings.watermark_color;
            mask_div.style.textAlign = "center";
            mask_div.style.width = defaultSettings.watermark_width + 'px';
            mask_div.style.height = defaultSettings.watermark_height + 'px';
            mask_div.style.display = "block";
            oTemp.appendChild(mask_div);
        }
    }
    (defaultSettings.Id?document.querySelector(defaultSettings.Id):document.body).appendChild(oTemp);
}

/**
 * 按照校区类型 是否显示模块
 * 传入需要显示的校区类型： 签约校区10001；小松鼠校区：10002；新标杆校区：10003
 */
export function showBySchoolType(SchoolTypes) {
    SchoolTypes = typeof SchoolTypes === 'object' ? SchoolTypes : [SchoolTypes]
    const crm_school_type = JSON.parse(localStorage.getItem(CRM_SCHOOL_TYPE))
    return SchoolTypes.indexOf(crm_school_type)
}

export function DateDiff(sDate1, sDate2){ //sDate1和sDate2是2002-12-18格式
    let aDate, oDate1, oDate2, iDays
    aDate = sDate1.split("-")
    oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]) //转换为12-18-2002格式
    aDate = sDate2.split("-")
    oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
    iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 /24) //把相差的毫秒数转换为天数
    return iDays
}

export function formatTel(tel=''){//手机号掩码
    const reg = /^(\d{3})\d{4}(\d{4})$/;
    return tel.replace(reg, "$1****$2");
}
export function formatName(name) {
    if (!name) {
        return '-'
    }
    let newStr;
    if (name.length === 2) {
        newStr = name.substr(0, 1) + '*';
    } else if (name.length > 2) {
        let char = '';
        for (let i = 0, len = name.length - 2; i < len; i++) {
            char += '*';
        }
        newStr = name.substr(0, 1) + char + name.substr(-1, 1);
    } else {
        newStr = name;
    }
    return newStr;
}
/**
 * 所属校区
 */
export function getSelectValNew(node) {
    return new Promise(resolve => {
        let selectArr = []
        function parseNode (nodeList) {
            nodeList.forEach(item => {
                if (
                    item.node && item.node.props && item.node.props.value && (item.node.props.value.split('_')[1]-0 > 0)
                ) {
                    selectArr.push(item.node.props.value)
                } else if (item.props && item.props.value && (item.props.value.split('_')[1]-0 > 0)) {
                    selectArr.push(item.props.value)
                }
                if (item.children && (item.children.length > 0)) {
                    parseNode(item.children)
                }
            })

        }
        parseNode(node);
        selectArr = [...new Set(selectArr)];
        resolve(selectArr)
    })
}
// 清除除指定格式的localstorage

export function clearLocalStorage() {
    const StorageList = Object.keys(localStorage)
    StorageList.forEach(item => {
        if (item.indexOf('Permanent_') !== 0) {
            localStorage.removeItem(item);
        }
    })
}


export function ExactSubtra(val=[]){
    let len = val.length
    if(len === 1 ) return val[0]
    let newList = new Array(len)
    for(let i=0;i<len;i++){
        try{
            newList[i] = val[i].toString().split(".")[1].length
        }catch(e){
            newList[i] = 0
        }
    }
    let m = Math.pow(10,Math.max(...newList))
    let n = Math.max(...newList)
    let res = val[0]*m
    let count = val
    count.shift()
    count.forEach(item=>{
        console.log(res,1);
        res -= item*m
    })
    return res/m.toFixed(n)
}


export function isJSON(str = "") {
    str = str + ""
    if (/^[\],:{}\s]*$/.test(str.replace(/\\["\\\/bfnrtu]/g, '@').
      replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
      replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
      return true;
    } else {
      return false;
    }
}

export function checkMediaType(url) {
    if(!url){
        return null
    }
    // 创建URL对象
    var link = new URL(url);
  
    // 获取路径部分（去除参数）
    var path = link.pathname;
  
    // 获取路径的最后一个点之后的内容作为文件扩展名
    var extension = path.split('.').pop().toLowerCase();
  
    // 声明支持的图片和视频文件扩展名
    var imageExtensions = ['bmp','jpeg' ,'jpg', 'jpeg', 'png', 'tif', 'gif', 'pcx', 'tga', 'exif', 'fpx', 'svg', 'psd', 'cdr', 'pcd', 'dxf', 'ufo', 'eps', 'ai', 'raw', 'WMF', 'webp', 'avif', 'apng'];
    var videoExtensions = ['mp4', 'wmv', 'avi', 'mov', 'flv', 'mpeg', 'webm'];
  
    // 判断文件扩展名是否在图片扩展名数组中
    if (imageExtensions.includes(extension)) {
      return 'image';
    }
  
    // 判断文件扩展名是否在视频扩展名数组中
    if (videoExtensions.includes(extension)) {
      return 'video';
    }
  
    // 扩展名不在图片或视频数组中,返回null表示无法确定媒体类型
    return null;
  }

  export function downloadFile(url, fileName) {
    if(checkMediaType(url) == 'image'){
        // 照片类型
        let image = new Image();
        image.src = url;
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function () {
            let c = document.createElement("canvas");
            c.width = image.width;
            c.height = image.height;
            c.getContext("2d").drawImage(image, 0, 0, image.width, image.height);
            let a = document.createElement("a");
            a.download = fileName;
            a.href = c.toDataURL("image/png");
            a.click();
        }
    }
    const a = document.createElement('a')
    a.href = url
    a.download = fileName || ""
    a.target = "blank"
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
